import SideMenu from '@/containers/side-menu/SideMenu.vue'
import Version from '@/pages/version/Version'

export default {
  path: '/version',
  name: 'Version',
  components: {
    mainContent: Version,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'welcome'
    }
  }
}